<template>
  <div id="historyTemplate">
    <v-card>
      <v-layout>
        <v-flex class="pr-2 pl-2">
          <v-text-field
            v-model="historySearch"
            append-icon="search"
            label="Search by Area / Updated By / Date"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-data-table
        :headers="historyHeaders"
        :items="data"
        :search="historySearch"
        no-data-text="No histories found"
        :pagination.sync="historyPagination" 
        class="pf-data-table"
      >
        <template v-slot:items="props">
          <tr v-if="props.item && props.item.updatedBy">
            <td>{{ props.index + 1 }}</td>
            <td>{{ props.item.entity }}</td>
            <td>{{ props.item.action ? props.item.action : 'N/A' }}</td>
            <td>{{ props.item.updatedBy.human.name }}</td>
            <td>{{ formatDateMethod(props.item.createdAt, 'MM/DD/YYYY hh:mm:ss') }}</td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>
<script>
/* global session config store moment */
import { formatDate } from '../../helpers/helpers';
export default {
  name: 'app-history',
  props: ['data'],
  data: () => ({
    config: config,
    historySearch: '',
    historyHeaders: [
      { text: '#', value: 'id', align: 'left' },
      { text: 'Area', value: 'entity', align: 'left' },
      { text: 'Action', value: 'action', align: 'left' },
      { text: 'Updated By', value: 'updatedBy.human.first_name' },
      { text: 'Date & Time', value: 'createdAt' }
    ],
    historyPagination: {
      rowsPerPage: config.dom.rowsPerPage,
      sortBy: ''
    }
  }),
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  methods: {
    formatDateMethod (date, format = 'MM/DD/YYYY') {
      return formatDate(date, format);
    }
  }
};
</script>
<style scoped>
  /*  */
</style>



// WEBPACK FOOTER //
// src/pages/History/list.vue